import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StopSearching } from './components/sections/StopSearching';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { SoundsFamiliar } from './components/sections/SoundsFamiliar';
import { FiveMinuteRoute } from './components/sections/FiveMinuteRoute';
import { Volumes } from './components/sections/Volumes';
import { InstantDelivery } from './components/sections/InstantDelivery';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { NextConsultation } from './components/sections/NextConsultation';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { TwoOptions } from './components/sections/TwoOptions';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full min-h-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3rc9co3oln7vn">
      <MetaPixel data-id="element-1" data-mp="3rd18nfm3z7mg" />
      <main data-id="element-2" data-mp="3relvsk63foaa">
        <Hero data-id="element-3" data-mp="5otf64sd496" />
        <StopSearching data-id="element-4" data-mp="6htjo98ovic" />
        <BeforeAfter data-id="element-5" data-mp="4n6a3ahwrb3" />
        <SoundsFamiliar data-id="element-6" data-mp="56qxrrj5tst" />
        <FiveMinuteRoute data-id="element-7" data-mp="2zl3c5m4yv85u" />
        <Volumes data-id="element-8" data-mp="2zlv84y2h77wn" />
        <InstantDelivery data-id="element-9" data-mp="2zmeo498kfm81" />
        <Bonuses data-id="element-10" data-mp="2zn6aquk6q9m6" />
        <Offer data-id="element-11" data-mp="33mov9p83gioh" />
        <NextConsultation data-id="element-12" data-mp="33m5be2yvvk7t" />
        <Guarantee data-id="element-13" data-mp="33nq921ghvj9w" />
        <Testimonials data-id="element-14" data-mp="33mymfg4vkvvr" />
        <About data-id="element-15" data-mp="33oi0r16z0wuw" />
        <Faq data-id="element-16" data-mp="38m1elzzrb7mb" />
        <TwoOptions data-id="element-17" data-mp="38li9jjv7gdpp" />
      </main>
      <Footer data-id="element-18" data-mp="38k6vmr81ppkv" />
      <FloatingCTA data-id="element-19" data-mp="38nunzn1r85y0" />
      <PurchasePopup data-id="element-20" data-mp="3dkuws5pznmst" />
    </div>;
}